export default (config: { props: { isInk?: boolean; isRTL?: boolean } }) => {
  const { props } = config

  const ARROW_POSITION_BLOCK = props.isInk ? '-9px' : '-12px'
  const ARROW_POSITION_INLINE = '-12px'

  return {
    arrow: {
      zIndex: 1,
      position: 'absolute',
      pointerEvents: 'none',
    },

    popoverTop: {
      insetBlockEnd: ARROW_POSITION_BLOCK,
    },

    popoverBottom: {
      insetBlockStart: ARROW_POSITION_BLOCK,
      transform: 'rotate(180deg)',
    },

    popoverLeft: {
      ...(props.isRTL
        ? { insetInlineStart: ARROW_POSITION_INLINE }
        : { insetInlineEnd: ARROW_POSITION_INLINE }),
      transform: 'rotate(270deg)',
    },

    popoverRight: {
      ...(props.isRTL
        ? { insetInlineEnd: ARROW_POSITION_INLINE }
        : { insetInlineStart: ARROW_POSITION_INLINE }),
      transform: 'rotate(90deg)',
    },
  } as const
}
